import fetch from "./fetch";
/**
 * 问卷管理
 */
const questionnaire = {
  //获取问卷模板
  getQuestionnaireTemplate(params) {
    return fetch({
      isLoading: true,
      url: "/questionnaireType/page",
      method: "GET",
      params,
    });
  },
  //获取问卷分页
  getQuestionnaire(params) {
    return fetch({
      isLoading: true,
      url: "/questionnaire/page",
      method: "GET",
      params,
    });
  },
  //模糊查询模板
  getRemoteTemplate(params) {
    return fetch({
      isLoading: true,
      url: "/questionnaireType/selectByType",
      method: "GET",
      params,
    });
  },
  //删除问卷
  deleteQuestionnaire(data) {
    return fetch({
      isLoading: true,
      url: "/questionnaire/delete",
      method: "POST",
      data,
    });
  },
  //发布问卷
  releaseQuestionnaire(data) {
    return fetch({
      isLoading: true,
      url: "/questionnaire/release",
      method: "POST",
      data,
    });
  },
  //创建问卷
  createQuestionnaire(data) {
    return fetch({
      isLoading: true,
      url: "/questionnaire/save",
      method: "POST",
      data,
    });
  },
  //修改问卷
  updateQuestionnaire(data) {
    return fetch({
      isLoading: true,
      url: "/questionnaire/update",
      method: "POST",
      data,
    });
  },
  //发布问卷
  releaseQuestionnaire(data) {
    return fetch({
      isLoading: true,
      url: "/questionnaire/release",
      method: "POST",
      data,
    });
  },
  //停止发布问卷
  stopQuestionnaire(data) {
    return fetch({
      isLoading: true,
      url: "/questionnaire/stop",
      method: "POST",
      data,
    });
  },
  //查看问卷
  checkQuestionnaireDetail(params) {
    return fetch({
      isLoading: true,
      url: "/questionnaireType/selectDetail",
      method: "GET",
      params,
    });
  },
};

export default questionnaire;
